module.exports = __webpack_public_path__ + "static/media/DSCN0336.3d317e1c.jpg";